const useToken = () => {
    return localStorage.getItem('ontime-token')
}
export default useToken